var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBananaAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3748 7.45194C19.4075 7.33486 19.4156 7.21286 19.4022 7.09204L19.1222 4.57272C19.0706 4.10765 19.046 3.5852 19.3772 3.25462C19.7509 2.88158 20.4287 2.79352 21.5047 3.86952C22.1093 4.47414 22.1196 5.16572 21.7553 6.00997C21.5175 6.56129 21.4378 7.17372 21.5856 7.75568C21.7385 8.35792 21.8402 8.98111 21.8859 9.62116C22.3184 15.6872 17.8856 21.0083 11.5668 21.4589C7.81678 21.7263 4.45539 20.6109 2.22918 18.2975C1.52075 17.5614 2.59182 16.5765 3.57676 16.848C9.80335 18.5641 17.6814 13.5139 19.3748 7.45194Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBananaAlt);
export default __webpack_public_path__ + "static/media/banana-alt.3750cf611568c6537a841e0c47d01cc8.svg";
export { ForwardRef as ReactComponent };